/* eslint-disable no-param-reassign */
import produce from 'immer';
import {
  SIGNUP, SIGNUP_SUCCESS, SIGNUP_FAILURE,
  SIGNIN, SIGNIN_SUCCESS, SIGNIN_FAILURE,
  LOGOUT,
  SILENT_LOGIN,
  UPDATE_PROFILE_SUCCESS,
} from 'src/actions/accountActions';

import { USER_ROLES, BUSINESS_TYPES } from 'src/config';


const initialState = {
  user: null,
  activeRole: USER_ROLES.ENGINEER, 
  businessInfo : {                
    type : BUSINESS_TYPES.GENERAL,
  },

};

const accountReducer = (state = initialState, action) => {
  switch (action.type) {

    case SIGNUP_SUCCESS: {
      return produce(state, (draft) =>{
          draft.user = null;
      })
    }


    case SIGNIN: {
      return produce(state, (draft) => {
        // Ensure we clear current session
        draft.user = null;
        draft.activeRole = null;
      });
    }

    case SIGNIN_SUCCESS: {
      const { user } = action.payload;

      return produce(state, (draft) => {
        draft.user = user;
        // draft.activeRole = "ADMIN";
        draft.activeRole = user?.role;
      });
    }

    case SIGNIN_FAILURE: {
      return produce(state, (draft) => {
        // Maybe store error
        draft.user = null;
        draft.activeRole = null;
      });
    }

    case LOGOUT: {
      return produce(state, (draft) => {
        draft.user = null;
        draft.activeRole = null;
      });
    }

    case SILENT_LOGIN: {
      const { user } = action.payload;

      return produce(state, (draft) => {
        draft.user = user;
        //draft.activeRole = "ADMIN";
        draft.activeRole = user?.role;
      });
    }

    case UPDATE_PROFILE_SUCCESS: {
      const { userData } = action.payload;

      return produce(state, (draft) => {
        //draft.user = user;

        draft.user.name = userData.name;
        draft.user.mobile = userData.mobile;
        draft.user.dob = userData.dob;
        draft.user.state = userData.state;
        draft.user.country = userData.country;

      });
    }

    default: {
      return state;
    }
  }
};

export default accountReducer;
